<template>
  <RDAnalyticsChart v-if="target === 'RDAnalytics'" :stats="data" class="printing" />
  <PDAnalyticsChart
    v-else-if="target === 'PDAnalytics'"
    :stats="data"
    :expand="true"
    :size="windowHeight * 0.8"
    class="printing"
    :zoom="options ? options.zoom : 'out'"
  />
  <PMAnalyticsChart v-else-if="target === 'PMAnalytics'" :chartData="data" :size="0.8" class="printing" />
  <HumanSkillChart v-else-if="target === 'HumanSkill'" :chartData="data" class="printing" />
  <PersonalityMatrixChart
    v-else-if="target === 'PersonalityMatrix'"
    :chartData="data"
    :size="windowWidth * 0.3"
    class="printing"
  />
  <People v-else-if="target === 'Judgement' && data" :printData="data" class="printing" :options="options" />
  <ProgressChart
    v-else-if="target === 'Progress' && data"
    id="print"
    :chartData="data"
    :options="options"
    class="printing"
    :height="windowHeight >= 1024 ? 70 : 90"
  >
    <template #header>
      {{ data.userName }}
    </template>
  </ProgressChart>
</template>
<style>
#app {
  height: unset;
}
</style>
// print blank page
<style>
html,
body {
  height: auto;
}
div.pm-analytics-chart-container > svg {
  height: 640px;
}
#app > div.legend,
#app > div.container {
  height: unset;
}
#app > div.container {
  margin: 20px 0px 0px 0px;
}
#app > div.container > svg {
  max-height: 700px;
}
</style>
<style lang="scss" scoped>
.printing {
  padding: $spacing-medium;
}
// print settings for Chrome only
@media print {
  @page {
    size: A4 landscape;
    margin: 8mm;
  }
  * {
    -webkit-print-color-adjust: exact;
  }
  body {
    width: 296mm;
    font-size: 0.9rem !important;
    line-height: 1.2;
  }
  :deep(.page-break) {
    break-before: page;
  }
  .printing {
    padding: 0 !important;
  }
  :deep(.area .uk-card) {
    padding: 8px;
  }
  :deep(.personality-detail) {
    td {
      padding: $spacing-minimum;
    }
    .descriptions > ul {
      margin: 0;
      line-height: 1.1;
    }
  }
  :deep(.self-evaluation) {
    .content {
      padding: 4px;
      th,
      td {
        padding: 2px;
      }
    }
  }
  :deep(.overall-judgement .card-content) {
    padding: 8px;
    .stability {
      margin-bottom: 8px;
    }
  }
  :deep(.activity-motivation-detail) {
    table.gauge-chart td.description {
      padding-bottom: 8px;
    }
  }
  :deep(.assignment-aptitude .content ul) {
    margin: 0;
    line-height: 1.1;
  }
  :deep(.behavior .left) {
    top: 25px;
  }
  :deep(div.similarity div.content) {
    margin-top: 10px;
    div.similarity-item ul {
      margin: 10px 0;
    }
  }
}
</style>
<script lang="ts">
import { Vue, Options } from "vue-class-component";
import RDAnalyticsChart from "./RDAnalyticsChart.vue";
import PDAnalyticsChart from "./PDAnalyticsChart.vue";
import PMAnalyticsChart from "./PMAnalyticsChart.vue";
import HumanSkillChart from "../atoms/HumanSkillChart.vue";
import PersonalityMatrixChart from "./PersonalityMatrixChart.vue";
import ProgressChart from "../molecules/ProgressChart.vue";
import People from "../pages/People.vue";
@Options({
  components: {
    RDAnalyticsChart,
    PDAnalyticsChart,
    PMAnalyticsChart,
    HumanSkillChart,
    People,
    PersonalityMatrixChart,
    ProgressChart
  }
})
/* eslint-disable */
export default class Print extends Vue {
  target = "";
  data?: any = null;
  options?: any = null;
  windowWidth!: number;
  windowHeight!: number;
  userName?: string;
  beforeCreate() {
    this.target = localStorage.getItem("printTarget")!;
  }
  beforeMount() {
    this.windowWidth = window.innerWidth;
    this.windowHeight = window.innerHeight;
  }
  mounted() {
    this.$nextTick(() => {
      this.data = JSON.parse(localStorage.getItem("printData")!);
      this.options = JSON.parse(localStorage.getItem("printOptions")!);
      if (this.options && this.target === "Progress") {
        this.options.plugins.tooltip.callbacks = {
          title: (tooltipItems: any) => {
            const title = tooltipItems[0].label.replaceAll(",", "").replaceAll("丨", "ー");
            return title;
          }
        };
      }
    });
  }
}
/* eslint-enable */
</script>
